import {
    Outlet,
    useLocation,
    useNavigate,
} from "react-router-dom";
import { Box, Stack, Typography } from '@mui/material';
import Sidebar from "../components/navigation/Sidebar";
import { useEffect, useState } from 'react';
import Breadcrumbs from "../components/navigation/Breadcrumbs";
import { useUserInfoQuery } from "../api/userApiSlice";
import { colours } from "../StyleConstants";
import AQTSnackbar from "../features/data-wrangler/components/AQTSnackbar";
import LassoSnackbar from "../components/LassoSnackbar";
import { RootState } from '../app/store';
import { useDispatch, useSelector } from "react-redux";
import {
    selectOpenDUCSnackbar,
    setOpenDUCSnackbar,
} from '../components/navigation/sidebarSlice';
import { setGlobusMessage } from '../reducers/globusMessageSlice';
import LassoNotification from "../features/common/LassoNotification";
import { useIsMobileDevice } from '../hooks/useIsMobileDevice';
import LassoModal from '../components/LassoModal';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const Layout = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [openSidebar] = useState(true);
    const { data, isFetching } = useUserInfoQuery({});
    const rootPathName = location?.pathname?.split("/")[1];
    const isMobileDevice = useIsMobileDevice();
    const complianceBannerText = window.env?.complianceBannerText
;
    //TODO: Abstract creating and updating notifications into a higher order component.
    const globusSnackbar = useSelector((state: RootState) => state.globusMessage);
    const isDUCSnackbarOpen = useSelector(selectOpenDUCSnackbar);

    useEffect(() => {
        if(data) {
            dispatch(setOpenDUCSnackbar(data?.roles.includes("DUCREQUIRED") && rootPathName !== "duc"));
        }
    }, [data, rootPathName])

    if (isFetching) {
        return <div>Loading...</div>;
    }

    return (
        <Box
            sx={{
                position: "fixed",
                width: "100%",
                height: "100%",
                overflow: "hidden",
                backgroundColor: "primary.dark",
                display: "flex",
                flexDirection: "row",
            }}
        >
            <Sidebar open={openSidebar}/>
            <Box
                sx={{
                    maxWidth: "calc(100vw - 200px)",
                    flexGrow: 1,
                    backgroundColor: colours.midnightBlue.blueBG,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {complianceBannerText &&
                <Box
                    sx={{
                        backgroundColor:"#F4DA84",
                        fontFamily: "Roboto",
                        textAlign: "center",
                        paddingX: 3,
                        paddingY: 1
                    }}
                >
                    <Typography fontWeight={"bold"} fontSize={"14px"} marginY={1} fontFamily={"Roboto"}>
                        {complianceBannerText}
                    </Typography>
                </Box>
                }
                {isMobileDevice
                    ?
                    <LassoModal open={true}>
                        <Stack padding={3} alignItems={"center"} gap={4}>
                            <Stack flexDirection={"row"} alignItems={"center"} gap={1}>
                                <CancelOutlinedIcon sx={{ color: colours.error.error, width: "35px", height: "35px" }}/>
                                <Typography variant={"h2"} fontSize={"28px"} fontWeight={600} textAlign={"center"}>Incompatible device</Typography>
                            </Stack>
                            <Typography textAlign={"center"}>
                      Sorry Mobile access is not currently supported (we know this is not ideal and we are working on it). Please use a desktop Chrome browser.
                            </Typography>
                        </Stack>

                    </LassoModal>

                    : <></>
                }
                <Breadcrumbs/>
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        px: 2,
                        pb: 1,
                        height: "calc(100% - 90px)",
                        overflow: "auto"
                    }}
                >
                    <Outlet/>
                </Box>

                <AQTSnackbar/>
                <LassoNotification/>
                <LassoSnackbar
                    open={isDUCSnackbarOpen}
                    closable={true}
                    variant="info"
                    message="Complete Data Use Certification (DUC) to access all features."
                    onDetailsClick={() => navigate("duc")}
                    close={() => {
                        dispatch(setOpenDUCSnackbar(false))
                    }}
                />
                <LassoSnackbar
                    open={globusSnackbar.open}
                    closable={true}
                    variant={globusSnackbar.variant}
                    message={globusSnackbar.message}
                    close={() => dispatch(setGlobusMessage({ ...globusSnackbar, open: false }))}
                />
            </Box>
        </Box>
    );
};

export default Layout;
